import { prop } from 'ramda';
import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledSideImageLayoutWrapper = styled.div`
  display: flex;
  min-height: 80vh;
  margin: 0 auto;
  max-width: ${tvar('measures.content.constrained')};
`;

export const StyledSideImageLayoutContent = styled.div`
  flex-basis: 100%;

  button,
  a {
    margin-bottom: ${tvar('space.x5')} !important;
  }
  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    flex-basis: 50%;
  }
`;

export const StyledSideImage = styled.div<{ src: string }>`
  background-image: url(${prop('src')});
  background-size: cover;
  background-position: top right;
  flex: 1 1 auto;
  align-self: stretch;
  margin-left: ${tvar('space.x10')};
  opacity: 0.85;
  filter: sepia(0.2);
  display: none;

  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    display: block;
  }
`;
